module.exports = __webpack_public_path__ + "img/shiyongTitleBg.6fb57de1.png";